import globals from '../../../../styles/globals';

export default (theme) => ({
    ...globals(theme),
    selectField: {
        marginBottom: 10
    }, 
    multiSelectInputLabel:{
         fontSize: '0.750rem'
    }	
});
